export default "__VITE_ASSET__CPWanZva__"